// /w/:wid/mail/:id? — on a phone the inbox, a conversation and a new letter are separate screens; on a tablet or PC with
// the room (layout.split) the inbox stays on the left and the conversation (or the new letter, /mail/new) opens beside it.
import { useParams } from "react-router-dom";
import { WorldPage } from "@/app/WorldPage";
import { art } from "@/kit/art";
import { useLayout } from "@/state/layout";
import { SplitNone } from "../reports/Reports";
import { Inbox, MailInbox } from "./MailInbox";
import { MailThread, Thread } from "./MailThread";
import { Compose, MailCompose } from "./MailCompose";

export function Mail() {
  const { id } = useParams();
  const { split } = useLayout();
  if (!split) return id === "new" ? <MailCompose /> : id ? <MailThread /> : <MailInbox />;
  return (
    <WorldPage layout="split">
      <div className="split">
        <div className="split-list"><Inbox /></div>
        <div className="split-item">
          {id === "new" ? <Compose /> : id ? <Thread key={id} /> : <SplitNone img={art.hero.mail} text="Choose a conversation, or write a new letter with the quill." />}
        </div>
      </div>
    </WorldPage>
  );
}
